import type { AdyenCheckoutError } from '@adyen/adyen-web';

export const ADYEN_SESSION_EXPIRED_ERROR_CODE = '14_0423';

export const getIsSessionExpiredError = (error: AdyenCheckoutError): boolean =>
  (error.cause as { errorCode?: string } | undefined)?.errorCode ===
  ADYEN_SESSION_EXPIRED_ERROR_CODE;
